import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicFormControls, BasicFieldCheckbox, BaasicButton } from 'core/components';
import { Content } from 'core/layouts';
import BaasicFieldDropdown from 'themes/components/select/BaasicFieldDropdown';
import { BasicTextArea } from 'core/components';
import BasicCheckbox from 'themes/components/checkbox/BasicCheckbox';
import { emailRecipientLabels  } from 'core/utils';

function CorporateContactEditTemplate({ corporateContactEditView, t }) {
    const {
        contentLoading,
        form,
        componentParams,
        contactDepartmentStore,
        id,
        facilities,
        handleDisabledFacility,
        disabledFacilities,
        displayFacilities,
        setDisplayFacilities,
    } = corporateContactEditView;

    function renderEmailSettings(form, emailRecipientLabels) {
        return emailRecipientLabels.map(({ name, label }) => {
            const emailField = form.$(name);
    
            return (
                <div key={name} className="card--settings--inner">
                    <div className='btn--toggled__label'>{label}</div>
                    <div className='btn--toggled__wrap'>
                        {['To', 'CC', ''].map((val, index) => (
                            <button
                                key={index}
                                type="button"
                                className={`btn btn--toggled ${
                                    emailField.value === val ? 'btn--primary' : ''
                                }`}
                                onClick={() => emailField.set(val)}
                            >
                                {val === '' ? <i className="u-icon u-icon--sml u-icon--inactive--toggle"></i> : val}
                            </button>
                        ))}
                    </div>
                </div>
            );
        });
    }

    return (
        <React.Fragment>
            <Content loading={contentLoading} >
                <div className="modal__header">
                    <h4 className="modal__header__title"> {id ? 'Edit' : 'Add' } Contact</h4>
                </div>
                <div className="modal__body">
                    <div className="row">
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BasicInput field={form.$('name')} />
                        </div>
                         <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BasicInput field={form.$('lastName')} />
                        </div>
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BaasicFieldDropdown field={form.$('corporateContactDepartments')} store={contactDepartmentStore} multi={true} autoClose={true} />
                        </div>
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BasicInput field={form.$('email')} />
                        </div>
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BasicInput field={form.$('phone')} />
                        </div>
                            <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                <label className='form__group__label'>Include On</label>
                                <div className="u-mar--bottom--sml card card--settings">
                                    {renderEmailSettings(form, emailRecipientLabels)}
                                </div> 
                            </div>
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <BasicTextArea rows="5" field={form.$('position')} />
                        </div>
                        <div className="form__group col col-lrg-6">
                            <BasicFieldCheckbox field={form.$('specialOrders')} />
                        </div>
                        <div className="form__group col col-lrg-12">
                            <div className="row">
                                <div className="form__group col col-lrg-12" >
                                    <div style={{display: 'inline-block', cursor: 'pointer'}} onClick={setDisplayFacilities}>
                                        <span>Facilities</span>
                                        <span className={displayFacilities ? "u-icon u-icon--med u-icon--arrow-up u-mar--left--sml" : "u-icon u-icon--med u-icon--arrow-down u-mar--left--sml"}></span>
                                    </div>
                                </div>
                                <div className="col col-sml-12 col-lrg-12">
                                    {displayFacilities && 
                                    <div className="row">
                                        {(facilities && facilities[0]) ? facilities.map(f => 
                                            <div key={f.id} className="form__group col col-lrg-6">
                                                <BasicCheckbox id={f.id} checked={ !disabledFacilities.includes(f.id)} label={f.name} onChange={() => handleDisabledFacility(f.id)} />
                                            </div>
                                        ) : (
                                            <div className="form__group col col-lrg-6">
                                                <p>No information to display</p>
                                            </div>
                                        )}
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
            <div className="modal__footer is-right">
                <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Save" className="btn btn--med btn--primary" />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => componentParams.modalParams.close()}
                />
            </div>
        </React.Fragment>
    )
}

CorporateContactEditTemplate.propTypes = {
    corporateContactEditView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(CorporateContactEditTemplate);